import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, BookOpen, Star } from 'lucide-react';
export function Hero() {
  return <section className="px-4 sm:px-6 lg:px-8 max-w-content mx-auto" data-id="element-149">
      <div className="text-center min-h-[100dvh] flex flex-col justify-center py-4 sm:py-12" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-151">
          <span className="inline-block py-1 px-3 rounded-full bg-f360-green text-white text-xs sm:text-sm font-bold tracking-wide uppercase mb-3 sm:mb-6" data-id="element-152">
            PROFE LISTO · FÚTBOL 360
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-3xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-3 sm:mb-6" data-id="element-153">
          Todo tu año de fútbol <br className="hidden sm:block" data-id="element-154" />
          resuelto de una vez.
        </motion.h1>

        {/* Product Image — entre el título y el subtítulo */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mt-3 mb-3 sm:mt-8 sm:mb-8 max-w-xs sm:max-w-3xl mx-auto" data-id="element-155">
          <img src="https://cdn.magicpatterns.com/uploads/bkdLoTvFbqqTRBKPYAMx1V/MOCKUP_FUTBOL.png" alt="Megapack FÚTBOL 360 — 15 Tomos, 6 Bonus y 2 Ebooks Élite" width={1080} height={1350} decoding="async" fetchPriority="high" className="w-full h-auto max-h-[34vh] sm:max-h-none object-contain mx-auto" data-id="element-156" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-sm sm:text-xl text-gray-600 max-w-3xl mx-auto mb-4 sm:mb-8" data-id="element-157">
          Megapack FÚTBOL 360 — El sistema completo de planificación y sesiones
          para el entrenador de fútbol argentino que no improvisa.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="flex flex-wrap justify-center items-center gap-3 sm:gap-8 mb-5 sm:mb-10 text-xs sm:text-base font-medium text-gray-700" data-id="element-158">
          <span className="flex items-center gap-2" data-id="element-159">
            <FileText className="w-5 h-5 text-f360-green" data-id="element-160" /> PDF
          </span>
          <span className="flex items-center gap-2" data-id="element-161">
            <Zap className="w-5 h-5 text-f360-green" data-id="element-162" /> Acceso Inmediato
          </span>
          <span className="flex items-center gap-2" data-id="element-163">
            <BookOpen className="w-5 h-5 text-f360-green" data-id="element-164" /> 15 Tomos + 6 Bonus
            + 2 Élite
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="flex flex-col items-center" data-id="element-165">
          <a href="#precio" className="inline-flex items-center justify-center w-full sm:w-auto px-6 sm:px-8 py-3.5 sm:py-4 text-base sm:text-lg font-bold text-white bg-f360-green hover:bg-f360-dark rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-166">
            💪 QUIERO MI FÚTBOL 360 AHORA
          </a>
          <p className="mt-3 sm:mt-4 text-xs sm:text-sm text-gray-500 flex flex-wrap justify-center gap-2 sm:gap-3" data-id="element-167">
            <span data-id="element-168">🛡️ Garantía 7 días</span>
            <span className="hidden sm:inline" data-id="element-169">·</span>
            <span data-id="element-170">🔒 Pago seguro</span>
            <span className="hidden sm:inline" data-id="element-171">·</span>
            <span data-id="element-172">💳 Tarjetas y transferencia</span>
          </p>
        </motion.div>
      </div>

      {/* Social Proof Bar */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.6
    }} className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 bg-white p-6 rounded-2xl shadow-sm border border-gray-100 my-16" data-id="element-173">
        <div className="text-center" data-id="element-174">
          <p className="text-3xl font-black text-f360-green" data-id="element-175">+300</p>
          <p className="text-sm text-gray-600 font-medium mt-1" data-id="element-176">
            profes confían
          </p>
        </div>
        <div className="text-center" data-id="element-177">
          <p className="text-3xl font-black text-f360-green" data-id="element-178">15+6</p>
          <p className="text-sm text-gray-600 font-medium mt-1" data-id="element-179">
            Tomos + Bonus
          </p>
        </div>
        <div className="text-center" data-id="element-180">
          <p className="text-3xl font-black text-f360-green" data-id="element-181">4.9/5</p>
          <p className="text-sm text-gray-600 font-medium mt-1" data-id="element-182">calificación</p>
        </div>
        <div className="text-center" data-id="element-183">
          <p className="text-3xl font-black text-f360-green" data-id="element-184">🇦🇷</p>
          <p className="text-sm text-gray-600 font-medium mt-1" data-id="element-185">Argentina</p>
        </div>
      </motion.div>

      {/* 3 Testimonios Cortos */}
      <div className="grid md:grid-cols-3 gap-6" data-id="element-186">
        {[{
        quote: 'Organicé toda la temporada en una tarde. Nunca más llego al entreno sin saber qué dar.',
        author: 'Martín P., Buenos Aires',
        role: 'Profe de fútbol infantil en Club de Barrio'
      }, {
        quote: 'Mis minis de 6 años mejoraron la conducción desde la primera semana con el Tomo 1.',
        author: 'Carolina G., Córdoba',
        role: 'Coordinadora de Fútbol Infantil'
      }, {
        quote: 'Antes tardaba 1 hora armando una sesión. Ahora son 5 minutos y el ejercicio ya está.',
        author: 'Federico R., Rosario',
        role: 'Profe de fútbol independiente'
      }].map((testimonial, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: i * 0.1
      }} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col" data-id="element-187">
            <div className="flex text-f360-gold mb-4" data-id="element-188">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-189" />)}
            </div>
            <p className="text-gray-700 italic mb-4 flex-grow" data-id="element-190">
              "{testimonial.quote}"
            </p>
            <div data-id="element-191">
              <p className="font-bold text-sm text-gray-900" data-id="element-192">
                {testimonial.author}
              </p>
              <p className="text-xs text-gray-500" data-id="element-193">{testimonial.role}</p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}